exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#measuringPointModal .v--modal-box.v--modal{min-width:380px!important;min-height:320px!important}#measuringPointModal .modal__content{overflow-y:hidden!important}#measuringPointModal .popup__content>li,#measuringPointModal .v-tabs,.feature-props__container{width:100%}#measuringPointModal .popup__content>li{padding-left:12px;padding-right:12px}#measuringPointModal .container{padding:0;padding-left:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-03ff1687","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/scada/modals/MeasuringPoint.vue
// module id = 1682
// module chunks = 0